import { apiProxyRequest } from "Api/apiProxyRequest";

import type { ContractsResponse } from "../types";

export const getContractsRequest = (billingProfileId: string) => {
  return apiProxyRequest<ContractsResponse>(
    `/billing/profiles/${billingProfileId}/contract`
  );
};
